import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"

import { createEnumChecker, iterateStringEnum } from "../../../../../../lib/enums"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

import { LabeledFilterSelect } from "../common/LabeledFilterSelect"

// `undefined` means "All types" (no resourceType is sent to the backend).
const ALL_TYPES = "ALL"

const isResourceType = createEnumChecker(ResourceType)

type UsageResourceTypeFilterProps = Readonly<{
    value: ResourceType | undefined
    onChange: (type: ResourceType | undefined) => void
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "15rem",
    },
}))

export function UsageResourceTypeFilter({ value, onChange }: UsageResourceTypeFilterProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="table-select-resource-type-filter-by-label-label" attrs={{ label: true }}>
            <LabeledFilterSelect
                id="usage-per-tenant-resource-type-select"
                label="Resource type"
                value={value ?? ALL_TYPES}
                onChange={(next) => onChange(isResourceType(next) ? next : undefined)}
                className={classes.input}
            >
                <MenuItem value={ALL_TYPES}>
                    <LocalizedStrict id="service-center-usage-per-tenant-resource-type-all">
                        <span>All types</span>
                    </LocalizedStrict>
                </MenuItem>
                {[...iterateStringEnum(ResourceType)].map((type) => (
                    <MenuItem key={type} value={type}>
                        <LocalizedEnum base="table-select-resource-type-filter-by" enumValue={type}>
                            <span>{type}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </LabeledFilterSelect>
        </LocalizedStrict>
    )
}
